import createContext from './Context';

export default createContext;
